import { candidateApi } from "../../services/apiService";
export const getDisclaimerStatus = () => {
  return candidateApi.get(`/profile/get-personal-disclaimer`);
};

export const saveDisclaimerStatus = (value) => {
  return candidateApi.post(`/profile/save-personal-disclaimer`, null, {
    params: { personalDisclaimer: value },
  });
};

const disclaimerApi = {
  getDisclaimerStatus,
  saveDisclaimerStatus,
};
export default disclaimerApi;
